import component from '.';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";

/** @type {UICore.ComponentMeta} */
const ColorPickerComponentMeta = {
  id: 'colorPicker',
  name: '颜色选择器',
  display: 'inline',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-color-select_1636363356004.png',
  category: '编辑框',
  component,
  bindings: [{
    id: 'v-model',
    main: true,
    required: true,
    prop: 'value',
    event: 'change',
    checkData: s => s.type === 'string'
  }],
  isFormEditor: true,
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读'
    }, {
      id: 'required',
      type: 'boolean',
      title: '必填'
    }, {
      id: 'placement',
      type: 'string',
      title: '弹窗位置',
      enum: [{
        value: 'top',
        label: '上'
      }, {
        value: 'right',
        label: '右'
      }, {
        value: 'bottom',
        label: '下'
      }, {
        value: 'left',
        label: '左'
      }, {
        value: 'topLeft',
        label: '上左'
      }, {
        value: 'topRight',
        label: '上右'
      }, {
        value: 'bottomLeft',
        label: '下左'
      }, {
        value: 'bottomRight',
        label: '下右'
      }, {
        value: 'leftTop',
        label: '左上'
      }, {
        value: 'leftBottom',
        label: '左下'
      }, {
        value: 'rightTop',
        label: '右上'
      }, {
        value: 'rightBottom',
        label: '右下'
      }],
      default: 'bottomLeft'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '输入内容变化时。 `$event` 为新的内容',
    arguments: [{
      type: 'string',
      description: '修改后的值'
    }]
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type !== 'string') return null;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER,
      layout: {
        type: 'colorPicker',
        bindings: {
          'v-model': dataPath
        }
      }
    };
  }
};
export default ColorPickerComponentMeta;